import Utils from '@/ecm/common/Utils';
export default class ContentTypeExportConfig {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.includeOriginalFile = false;
        this.exportMultipleFiles = false;
        this.exportFileNamePrefix = '';
        this.exportFileNameSuffix = '';
        this.exportFileNameExtension = 'TXT';
        this.exportToServerLocation = false;
        this.exportFilePath = '';
        this.exportEncoding = '65001'; // UTF-8
        this.conditionStr = '';
        this.displayConditionStr = '';
        this.exportMask = '';
        this.exportWithHeaders = false;

        if (dto) {
            this.includeOriginalFile = dto.includeOriginalFile;
            this.exportMultipleFiles = dto.exportMultipleFiles;
            this.exportFileNamePrefix = dto.exportFileNamePrefix;
            this.exportFileNameSuffix = dto.exportFileNameSuffix;
            if (dto.exportFileNameExtension) {
                this.exportFileNameExtension = dto.exportFileNameExtension;
            }
            if (dto.exportFilePath) {
                this.exportToServerLocation = true;
                this.exportFilePath = dto.exportFilePath;
            }
            this.exportEncoding = dto.exportEncoding + '';
            this.conditionStr = dto.conditionStr;
            this.exportMask = dto.exportMask;
            this.exportWithHeaders = dto.exportWithHeaders;
            this.displayConditionStr = dto.displayConditionStr;
        }
    }

    toDto () {
        return {
            IncludeOriginalFile: this.includeOriginalFile,
            ExportMultipleFiles: this.exportMultipleFiles,
            ExportFileNamePrefix: this.exportFileNamePrefix,
            ExportFileNameSuffix: this.exportFileNameSuffix,
            ExportFileNameExtension: this.exportFileNameExtension,
            ExportFilePath: this.exportToServerLocation ? this.exportFilePath : '',
            ExportEncoding: this.exportEncoding,
            ConditionStr: this.conditionStr,
            ExportMask: this.exportMask,
            ExportWithHeaders: this.exportWithHeaders,
            DisplayConditionStr: this.displayConditionStr,
        };
    }
}
